import { calcTotalEnergy, calcTotalSave, getRecommand } from '@/constants/cost-saving';
import { getSolarRecommand } from '@/service/solar-calculator';
import { useGlobal } from '@/utils/useGlobal';
import EFPicture from 'elem/compCommon/EFPicture';
import { cloneDeep } from 'lodash';
import { Scrollbar } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';
import BestSelling from './BestSelling';
import css from './index.module.scss';
import EcoDesignEventsBus from 'eco-design-micro/EcoDesignEventsBus';
import { ENUM_ECO_CART_EVENT, ItfEcoCartItem } from 'eco-design-components/elements/eco-cart/type.d';

export default function D() {
    const { useLang, useState, useEffect, useRouter, Link, gtm } = useGlobal();
    const { t } = useLang('costsaving');
    const { locale } = useRouter();
    const [gap, setGap] = useState(24);
    const [flag, setFlag] = useState(false);
    const [flag2, setFlag2] = useState(false);
    const [flag3, setFlag3] = useState(false);

    const SolarPanels = [
        {
            img: '',
            quantity: 1,
            isActive: true,
            energy: 400,
            id: '400w_rigid',
            title: '400w RIGID',
            cartTitle: '400w RIGID',
            productId: (() => {
                const localMap: any = {
                    us: '6841245925449',
                    ca: '',
                };
                return localMap[locale] || localMap.us;
            })(),
            variantId: (() => {
                const localMap: any = {
                    us: '40250363478089',
                    ca: '',
                };
                return localMap[locale] || localMap.us;
            })(),
        },
        {
            img: '',
            quantity: 1,
            isActive: true,
            energy: 800,
            id: '2*400w_rigid',
            title: '2 x 400W Rigid',
            cartTitle: '2 x 400W Rigid',
            productId: (() => {
                const localMap: any = {
                    us: '6841245925449',
                    ca: '',
                };
                return localMap[locale] || localMap.us;
            })(),
            variantId: (() => {
                const localMap: any = {
                    us: '40250363478089',
                    ca: '',
                };
                return localMap[locale] || localMap.us;
            })(),
        },
        {
            img: '',
            quantity: 1,
            isActive: true,
            energy: 400,
            id: '400w',
            title: t('secD_card_400w'),
            cartTitle: t('secD_cart_400w_name'),
            productId: (() => {
                const localMap: any = {
                    us: '6618094960713',
                    ca: '7287920001178',
                    za: '7027755253969',
                };
                return localMap[locale] || localMap.us;
            })(),
            variantId: (() => {
                const localMap: any = {
                    us: '39998021697609',
                    ca: '42092770263194',
                    za: '41630472405201',
                };
                return localMap[locale] || localMap.us;
            })(),
        },
        {
            img: '',
            quantity: 1,
            isActive: false,
            energy: 220,
            id: '220w',
            title: t('secD_card_220w'),
            cartTitle: t('secD_cart_220w_name'),
            productId: (() => {
                const localMap: any = {
                    us: '7003545108553',
                    ca: '7296662896794',
                    za: '7027754926289',
                };
                return localMap[locale] || localMap.us;
            })(),
            variantId: (() => {
                const localMap: any = {
                    us: '41670394576969',
                    ca: '43874721824922',
                    za: '41630471913681',
                };
                return localMap[locale] || localMap.us;
            })(),
        },
        {
            img: '',
            quantity: 1,
            isActive: false,
            energy: 160,
            id: '160w',
            title: t('secD_card_160w'),
            cartTitle: t('secD_cart_160w_name'),
            productId: (() => {
                const localMap: any = {
                    us: '4605523198025',
                    ca: '6609119936666',
                    za: '7027757023441',
                };
                return localMap[locale] || localMap.us;
            })(),
            variantId: (() => {
                const localMap: any = {
                    us: '40573832429641',
                    ca: '43762372739226',
                    za: '41611172741329',
                };
                return localMap[locale] || localMap.us;
            })(),
        },
        {
            img: '',
            quantity: 1,
            isActive: false,
            energy: 125,
            id: '125w',
            title: '125W',
            cartTitle: '125W',
            productId: (() => {
                const localMap: any = {
                    us: '7354152681545',
                    ca: '15030544531827',
                    za: '7027755876561',
                };
                return localMap[locale] || localMap.us;
            })(),
            variantId: (() => {
                const localMap: any = {
                    us: '41838060404809',
                    ca: '52317425009011',
                    za: '41611171463377',
                };
                return localMap[locale] || localMap.us;
            })(),
        },
        {
            img: '',
            quantity: 1,
            isActive: false,
            energy: 110,
            id: '110w',
            title: t('secD_card_110w'),
            cartTitle: t('secD_cart_110w_name'),
            productId: (() => {
                const localMap: any = {
                    us: '4318647222345',
                    ca: '5511642644634',
                    za: '7027755876561',
                };
                return localMap[locale] || localMap.us;
            })(),
            variantId: (() => {
                const localMap: any = {
                    us: '39998109941833',
                    ca: '43725961199770',
                    za: '41611171463377',
                };
                return localMap[locale] || localMap.us;
            })(),
        },
        {
            img: '',
            quantity: 1,
            isActive: false,
            energy: 500,
            id: '500w',
            title: t('secD_card_500w'),
            cartTitle: t('secD_cart_500w_name'),
            productId: (() => {
                const localMap: any = {
                    ca: '15030544531827',
                };
                return localMap[locale] || localMap.ca;
            })(),
            variantId: (() => {
                const localMap: any = {
                    ca: '52317425009011',
                };
                return localMap[locale] || localMap.ca;
            })(),
        },

        {
            img: '',
            quantity: 1,
            isActive: false,
            energy: 800,
            id: '2*400w',
            title: '2 x 400W',
            cartTitle: '2*400W Portable Solar Panel',
            productId: (() => {
                const localMap: any = {
                    us: '6618094960713',
                    ca: '7959022207130',
                };
                return localMap[locale] || localMap.ca;
            })(),
            variantId: (() => {
                const localMap: any = {
                    us: '54553987612745',
                    ca: '44031270322330',
                };
                return localMap[locale] || localMap.ca;
            })(),
        },
        {
            img: '',
            quantity: 1,
            isActive: false,
            energy: 500,
            id: '4*125w',
            title: '500W Solar Kit',
            cartTitle: '500W Solar Kit',
            productId: (() => {
                const localMap: any = {
                    us: '7354152681545',
                    ca: '15030544531827',
                };
                return localMap[locale] || localMap.ca;
            })(),
            variantId: (() => {
                const localMap: any = {
                    us: '41838060404809',
                    ca: '52317425009011',
                };
                return localMap[locale] || localMap.ca;
            })(),
        },
        {
            img: '',
            quantity: 1,
            isActive: false,
            energy: 440,
            id: '2*220w',
            title: '2 x 220W',
            cartTitle: '2 x 220W Portable Solar Panel',
            productId: (() => {
                const localMap: any = {
                    us: '7003545108553',
                    ca: '15030544531827',
                };
                return localMap[locale] || localMap.ca;
            })(),
            variantId: (() => {
                const localMap: any = {
                    us: '54553987547209',
                    ca: '52317425009011',
                };
                return localMap[locale] || localMap.ca;
            })(),
        },
        {
            img: '',
            quantity: 1,
            isActive: false,
            energy: 200,
            id: '2*100w_rigid',
            title: '2 x 100W Rigid',
            cartTitle: '2 x 100W Rigid',
            productId: (() => {
                const localMap: any = {
                    us: '6808946278473',
                    ca: '7434967646362',
                };
                return localMap[locale] || localMap.ca;
            })(),
            variantId: (() => {
                const localMap: any = {
                    us: '40133459640393',
                    ca: '42301016375450',
                };
                return localMap[locale] || localMap.ca;
            })(),
        },
    ];

    const [solarpanels, setSolarpanels] = useState(SolarPanels);

    let cards: any = [
        {
            img: `/responsive/picture/common-products/deltapro.png`,
            tag: locale === 'ca' ? '' : t('common_card_tag'),
            power: t('secD_card1_power'),
            title: t('secD_card1_title'),
            id: 'deltapro',
            link_more: (() => {
                const localMap: any = {
                    us: 'https://us.ecoflow.com/products/delta-pro-portable-power-station?variant=40516140138569',
                    ca: 'https://ca.ecoflow.com/products/delta-pro-portable-power-station?variant=43725958873242',
                    za: 'https://za.ecoflow.com/products/delta-pro-portable-power-station?variant=41601871610065',
                };
                return localMap[locale] || localMap.us;
            })(),
            productId: (() => {
                const localMap: any = {
                    us: '6585086836809',
                    ca: '6944959824026',
                    za: '7027758137553',
                };
                return localMap[locale] || localMap.us;
            })(),
            variantId: (() => {
                const localMap: any = {
                    us: '40516140138569',
                    ca: '43725958873242',
                    za: '41601871610065',
                };
                return localMap[locale] || localMap.us;
            })(),
            descArr: [t('secD_card1_desc1'), t('secD_card1_desc2'), t('secD_card1_desc3')],
            children: solarpanels.filter((item: any) => {
                const keys: {
                    [key: string]: any;
                } = {
                    za: ['400w', '220w', '160w'],
                    ca: ['400w', '220w', '500w'],
                    us: ['400w', '220w'],
                };
                return (keys?.[locale] || ['400w', '220w']).includes(item.id);
            }),
        },
        {
            img: `/responsive/picture/common-products/delta2max.png`,
            tag: locale === 'ca' ? '' : t('common_card_tag'),
            power: t('secD_card2_power'),
            title: t('secD_card2_title'),
            id: 'delta2max',
            bestSelling: true,
            link_more: (() => {
                const localMap: any = {
                    us: 'https://us.ecoflow.com/products/delta-2-max-portable-power-station?variant=40538145095753',
                    ca: 'https://ca.ecoflow.com/products/delta-2-max-portable-power-station?variant=43592212775066',
                    za: 'https://za.ecoflow.com/products/delta-2-max-portable-power-station?variant=41935518335185',
                };
                return localMap[locale] || localMap.us;
            })(),
            productId: (() => {
                const localMap: any = {
                    us: '6905537888329',
                    ca: '7825964400794',
                    za: '7352407982289',
                };
                return localMap[locale] || localMap.us;
            })(),
            variantId: (() => {
                const localMap: any = {
                    us: '40538145095753',
                    ca: '43592212775066',
                    za: '41935518335185',
                };
                return localMap[locale] || localMap.us;
            })(),
            descArr: [t('secD_card2_desc1'), t('secD_card2_desc2'), t('secD_card2_desc3')],
            children: solarpanels.filter((item: any) =>
                (locale === 'za' ? ['400w', '220w', '160w', '120w'] : ['400w', '220w', '160w', '110w']).includes(item.id),
            ),
        },
        {
            img: `/responsive/picture/common-products/delta2.png`,
            tag: locale === 'ca' ? '' : t('common_card_tag'),
            power: t('secD_card3_power'),
            title: t('secD_card3_title'),
            id: 'delta2',
            link_more: (() => {
                const localMap: any = {
                    us: 'https://us.ecoflow.com/products/delta-2-portable-power-station?variant=40569176326217',
                    ca: 'https://ca.ecoflow.com/products/delta-2-portable-power-station?variant=43725896056986',
                    za: 'https://za.ecoflow.com/products/delta-2-portable-power-station?variant=41620506575057',
                };
                return localMap[locale] || localMap.us;
            })(),
            productId: (() => {
                const localMap: any = {
                    us: '7323318190153',
                    ca: '7440912384154',
                    za: '7187057803473',
                };
                return localMap[locale] || localMap.us;
            })(),
            variantId: (() => {
                const localMap: any = {
                    us: '41719074324553',
                    ca: '43725896056986',
                    za: '41620506575057',
                };
                return localMap[locale] || localMap.us;
            })(),
            descArr: [t('secD_card3_desc1'), t('secD_card3_desc2'), t('secD_card3_desc3')],
            children: solarpanels.filter((item: any) =>
                (locale === 'za' ? ['400w', '220w', '160w', '120w'] : ['400w', '220w', '160w', '110w']).includes(item.id),
            ),
        },
    ];

    if (['us'].includes(locale)) {
        cards = [
            {
                tag: t('common_card_tag'),
                img: '',
                title: 'EcoFlow DELTA Pro Ultra',
                power: '6kWh | 7200W | 120V/240V',
                id: 'dpu',
                link_more: (() => {
                    const localMap: any = {
                        us: 'https://us.ecoflow.com/products/delta-pro-ultra-includes-extra-battery?variant=41963472289865',
                        ca: 'https://ca.ecoflow.com/products/delta-pro-ultra?variant=44244774650010',
                    };
                    return localMap[locale] || localMap.us;
                })(),
                productId: (() => {
                    const localMap: any = {
                        us: '7383152951369',
                        ca: '8006700236954',
                    };
                    return localMap[locale] || localMap.us;
                })(),
                variantId: (() => {
                    const localMap: any = {
                        us: '41963472289865',
                        ca: '44244774650010',
                    };
                    return localMap[locale] || localMap.us;
                })(),
                descArr: ['5.6-16.8kW dual solar input', '80% capacity after 3500+ cycles', '5 charging options'],
                children: solarpanels.filter((item: any) => (locale === 'us' ? ['2*400w_rigid', '400w'] : ['400w', '500w']).includes(item.id)),
            },
            {
                tag: t('common_card_tag'),
                img: 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1718875722852/sl_DP3.png',
                title: 'EcoFlow DELTA Pro 3',
                power: '4-48kWh | 4000W｜120V/240V',
                id: 'deltapro3',
                link_more: (() => {
                    const localMap: any = {
                        us: 'https://us.ecoflow.com/products/delta-pro-3-portable-power-station?variant=41385721004105',
                        ca: 'https://ca.ecoflow.com/products/delta-pro-3-portable-power-station',
                    };
                    return localMap[locale] || localMap.us;
                })(),
                productId: (() => {
                    const localMap: any = {
                        us: '7185477075017',
                        ca: '8231332380826',
                    };
                    return localMap[locale] || localMap.us;
                })(),
                variantId: (() => {
                    const localMap: any = {
                        us: '41385721004105',
                        ca: '44902384599194',
                    };
                    return localMap[locale] || localMap.us;
                })(),
                descArr: ['2600W Dual Solar Input', 'LFP battery, 4000 cycles to 80%, with an 11-year+ life span', 'Charging from 0-80% in 50 min'],
                children: solarpanels.filter((item: any) => (locale === 'us' ? ['400w', '220w', '125w'] : ['400w', '220w', '500w']).includes(item.id)),
            },
            {
                tag: t('common_card_tag'),
                img: '',
                title: 'DELTA 3 Ultra Plus',
                power: '3072Wh Capacity | 3600W Output | Smart Output Priority ',
                id: 'delta3ultraplus',
                link_more: (() => {
                    const localMap: any = {
                        us: 'https://us.ecoflow.com/products/delta-3-ultra-series-portable-power-station?variant=54718705008713',
                        ca: 'https://ca.ecoflow.com/products/delta-3-ultra-series-portable-power-station?variant=62106740556147',
                    };
                    return localMap[locale] || localMap.us;
                })(),
                productId: (() => {
                    const localMap: any = {
                        us: '15386143096905',
                        ca: '15164531016051',
                    };
                    return localMap[locale] || localMap.us;
                })(),
                variantId: (() => {
                    const localMap: any = {
                        us: '54718705008713',
                        ca: '62106740556147',
                    };
                    return localMap[locale] || localMap.us;
                })(),
                descArr: [
                    'Run your energy-hungry appliances with industry-leading output',
                    'Extend runtime for your high-priority items using the smart output priority feature. ',
                    'Supports 6 fast-charging methods.',
                ],
                children: solarpanels.filter((item: any) => ['400w', '2*400w', '4*125w'].includes(item.id)),
            },
            {
                img: ``,
                tag: locale === 'ca' ? '' : t('common_card_tag'),
                power: t('secD_card1_power'),
                title: t('secD_card1_title'),
                id: 'deltapro',
                link_more: (() => {
                    const localMap: any = {
                        us: 'https://us.ecoflow.com/products/delta-pro-portable-power-station?variant=40516140138569',
                        ca: 'https://ca.ecoflow.com/products/delta-pro-portable-power-station?variant=43725958873242',
                        za: 'https://za.ecoflow.com/products/delta-pro-portable-power-station?variant=41601871610065',
                    };
                    return localMap[locale] || localMap.us;
                })(),
                productId: (() => {
                    const localMap: any = {
                        us: '6585086836809',
                        ca: '6944959824026',
                        za: '7027758137553',
                    };
                    return localMap[locale] || localMap.us;
                })(),
                variantId: (() => {
                    const localMap: any = {
                        us: '40516140138569',
                        ca: '43725958873242',
                        za: '41601871610065',
                    };
                    return localMap[locale] || localMap.us;
                })(),
                descArr: [t('secD_card1_desc1'), t('secD_card1_desc2'), t('secD_card1_desc3')],
                children: solarpanels.filter((item: any) => {
                    const keys: {
                        [key: string]: any;
                    } = {
                        za: ['400w', '220w', '160w'],
                        ca: ['400w', '220w', '500w'],
                        us: ['400w', '220w'],
                    };
                    return (keys?.[locale] || ['400w', '220w']).includes(item.id);
                }),
            },
            {
                tag: t('common_card_tag'),
                img: '',
                title: 'DELTA 3 Max Plus',
                power: '2048Wh Capacity | 2400W Output | 10ms UPS',
                id: 'delta3maxplus',
                link_more: (() => {
                    const localMap: any = {
                        us: 'https://us.ecoflow.com/products/delta-3-max-series-portable-power-station?variant=54718699962441',
                        ca: 'https://ca.ecoflow.com/products/delta-3-max-series-portable-power-station?variant=62106661618035',
                    };
                    return localMap[locale] || localMap.us;
                })(),
                productId: (() => {
                    const localMap: any = {
                        us: '15386147061833',
                        ca: '15164532654451',
                    };
                    return localMap[locale] || localMap.us;
                })(),
                variantId: (() => {
                    const localMap: any = {
                        us: '54718699962441',
                        ca: '62106661618035',
                    };
                    return localMap[locale] || localMap.us;
                })(),
                descArr: [
                    'The most lightweight 2kWh portable power station.* Cover your home essentials and outdoor adventures with quiet and reliable power.',
                ],
                children: solarpanels.filter((item: any) => ['400w', '4*125w'].includes(item.id)),
            },
            {
                img: ``,
                tag: locale === 'ca' ? '' : t('common_card_tag'),
                power: t('secD_card2_power'),
                title: t('secD_card2_title'),
                id: 'delta2max',
                bestSelling: true,
                link_more: (() => {
                    const localMap: any = {
                        us: 'https://us.ecoflow.com/products/delta-2-max-portable-power-station?variant=40538145095753',
                        ca: 'https://ca.ecoflow.com/products/delta-2-max-portable-power-station?variant=43592212775066',
                        za: 'https://za.ecoflow.com/products/delta-2-max-portable-power-station?variant=41935518335185',
                    };
                    return localMap[locale] || localMap.us;
                })(),
                productId: (() => {
                    const localMap: any = {
                        us: '6905537888329',
                        ca: '7825964400794',
                        za: '7352407982289',
                    };
                    return localMap[locale] || localMap.us;
                })(),
                variantId: (() => {
                    const localMap: any = {
                        us: '40538145095753',
                        ca: '43592212775066',
                        za: '41935518335185',
                    };
                    return localMap[locale] || localMap.us;
                })(),
                descArr: [t('secD_card2_desc1'), t('secD_card2_desc2'), t('secD_card2_desc3')],
                children: solarpanels.filter((item: any) =>
                    (locale === 'za' ? ['400w', '220w', '160w', '120w'] : ['400w', '220w', '160w', '110w']).includes(item.id),
                ),
            },
            {
                img: ``,
                tag: locale === 'ca' ? '' : t('common_card_tag'),
                power: '1024Wh |1800W',
                title: 'DELTA 3 Classic',
                id: 'delta3classic',
                bestSelling: true,
                link_more: (() => {
                    const localMap: any = {
                        us: 'https://us.ecoflow.com/products/delta-3-classic-portable-power-station?variant=54691871227977',
                        ca: 'https://ca.ecoflow.com/products/delta-3-classic-portable-power-station?variant=62060639584627',
                    };
                    return localMap[locale] || localMap.us;
                })(),
                productId: (() => {
                    const localMap: any = {
                        us: '15386067730505',
                        ca: '15164532916595',
                    };
                    return localMap[locale] || localMap.us;
                })(),
                variantId: (() => {
                    const localMap: any = {
                        us: '54691871227977',
                        ca: '62060639584627',
                    };
                    return localMap[locale] || localMap.us;
                })(),
                descArr: ['Ultra-versatile 4 charging options and a 45-minute fast-charge.'],
                children: solarpanels.filter((item: any) => ['220w', '2*100w_rigid'].includes(item.id)),
            },
            // ...cards,

            {
                img: ``,
                tag: locale === 'ca' ? '' : t('common_card_tag'),
                power: '3072Wh Capacity | 3600W Output | 4 Charging Options',
                title: 'DELTA 3 Ultra',
                id: 'delta3ultra',
                bestSelling: true,
                link_more: (() => {
                    const localMap: any = {
                        us: 'https://us.ecoflow.com/products/delta-3-ultra-series-portable-power-station?variant=54692148871241',
                        ca: 'https://ca.ecoflow.com/products/delta-3-ultra-series-portable-power-station?variant=62060629590387',
                    };
                    return localMap[locale] || localMap.us;
                })(),
                productId: (() => {
                    const localMap: any = {
                        us: '15386143096905',
                        ca: '15164531016051',
                    };
                    return localMap[locale] || localMap.us;
                })(),
                variantId: (() => {
                    const localMap: any = {
                        us: '54692148871241',
                        ca: '62060629590387',
                    };
                    return localMap[locale] || localMap.us;
                })(),
                descArr: [
                    'Sufficient power for daily use and essential backups.',
                    '4 charging options including AC, solar, alternator, and generator charging.',
                ],
                children: solarpanels.filter((item: any) => ['400w', '4*125w', '2*220w'].includes(item.id)),
            },
            {
                img: ``,
                tag: locale === 'ca' ? '' : t('common_card_tag'),
                power: '2048Wh Capacity | 2400W Output | 10ms UPS',
                title: 'DELTA 3 Max',
                id: 'delta3max',
                bestSelling: true,
                link_more: (() => {
                    const localMap: any = {
                        us: 'https://us.ecoflow.com/products/delta-3-max-series-portable-power-station?variant=54692162764873',
                        ca: 'https://ca.ecoflow.com/products/delta-3-max-series-portable-power-station?variant=62060638372211',
                    };
                    return localMap[locale] || localMap.us;
                })(),
                productId: (() => {
                    const localMap: any = {
                        us: '15386147061833',
                        ca: '15164532654451',
                    };
                    return localMap[locale] || localMap.us;
                })(),
                variantId: (() => {
                    const localMap: any = {
                        us: '54692162764873',
                        ca: '62060638372211',
                    };
                    return localMap[locale] || localMap.us;
                })(),
                descArr: [
                    'The most lightweight 2kWh portable power station.* Cover your home essentials and outdoor adventures with quiet and reliable power.',
                    'Lightweight for on-the-go adventures, charged with solar energy in approx. 11.6 hours with 220W solar panel.',
                    'Compared with EcoFlow DELTA 2 Max.',
                ],
                children: solarpanels.filter((item: any) => ['2*220w', '400w', '4*125w'].includes(item.id)),
            },
        ];
    }

    if (['ca'].includes(locale)) {
        cards = [
            {
                tag: t('common_card_tag'),
                img: '',
                title: 'EcoFlow DELTA Pro Ultra',
                power: '6kWh | 7200W | 120V/240V',
                id: 'dpu',
                link_more: (() => {
                    const localMap: any = {
                        us: 'https://us.ecoflow.com/products/delta-pro-ultra-includes-extra-battery?variant=41963472289865',
                        ca: 'https://ca.ecoflow.com/products/delta-pro-ultra?variant=44244774650010',
                    };
                    return localMap[locale] || localMap.us;
                })(),
                productId: (() => {
                    const localMap: any = {
                        us: '7383152951369',
                        ca: '8006700236954',
                    };
                    return localMap[locale] || localMap.us;
                })(),
                variantId: (() => {
                    const localMap: any = {
                        us: '41963472289865',
                        ca: '44244774650010',
                    };
                    return localMap[locale] || localMap.us;
                })(),
                descArr: ['5.6-16.8kW dual solar input', '80% capacity after 3500+ cycles', '5 charging options'],
                children: solarpanels.filter((item: any) => (locale === 'us' ? ['2*400w_rigid', '400w'] : ['400w', '500w']).includes(item.id)),
            },
            {
                tag: t('common_card_tag'),
                img: 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1718875722852/sl_DP3.png',
                title: 'EcoFlow DELTA Pro 3',
                power: '4-48kWh | 4000W｜120V/240V',
                id: 'deltapro3',
                link_more: (() => {
                    const localMap: any = {
                        us: 'https://us.ecoflow.com/products/delta-pro-3-portable-power-station?variant=41385721004105',
                        ca: 'https://ca.ecoflow.com/products/delta-pro-3-portable-power-station',
                    };
                    return localMap[locale] || localMap.us;
                })(),
                productId: (() => {
                    const localMap: any = {
                        us: '7185477075017',
                        ca: '8231332380826',
                    };
                    return localMap[locale] || localMap.us;
                })(),
                variantId: (() => {
                    const localMap: any = {
                        us: '41385721004105',
                        ca: '44902384599194',
                    };
                    return localMap[locale] || localMap.us;
                })(),
                descArr: ['2600W Dual Solar Input', 'LFP battery, 4000 cycles to 80%, with an 11-year+ life span', 'Charging from 0-80% in 50 min'],
                children: solarpanels.filter((item: any) => (locale === 'us' ? ['400w', '220w', '125w'] : ['400w', '220w', '500w']).includes(item.id)),
            },
            {
                tag: t('common_card_tag'),
                img: '',
                title: 'DELTA 3 Ultra Plus',
                power: '3072Wh Capacity | 3600W Output | Smart Output Priority ',
                id: 'delta3ultraplus',
                link_more: (() => {
                    const localMap: any = {
                        us: 'https://us.ecoflow.com/products/delta-3-ultra-series-portable-power-station?variant=54718705008713',
                        ca: 'https://ca.ecoflow.com/products/delta-3-ultra-series-portable-power-station?variant=62106740556147',
                    };
                    return localMap[locale] || localMap.us;
                })(),
                productId: (() => {
                    const localMap: any = {
                        us: '15386143096905',
                        ca: '15164531016051',
                    };
                    return localMap[locale] || localMap.us;
                })(),
                variantId: (() => {
                    const localMap: any = {
                        us: '54718705008713',
                        ca: '62106740556147',
                    };
                    return localMap[locale] || localMap.us;
                })(),
                descArr: [
                    'Run your energy-hungry appliances with industry-leading output',
                    'Extend runtime for your high-priority items using the smart output priority feature. ',
                    'Supports 6 fast-charging methods.',
                ],
                children: solarpanels.filter((item: any) => ['400w', '2*400w', '4*125w'].includes(item.id)),
            },
            {
                img: ``,
                tag: locale === 'ca' ? '' : t('common_card_tag'),
                power: t('secD_card1_power'),
                title: t('secD_card1_title'),
                id: 'deltapro',
                link_more: (() => {
                    const localMap: any = {
                        us: 'https://us.ecoflow.com/products/delta-pro-portable-power-station?variant=40516140138569',
                        ca: 'https://ca.ecoflow.com/products/delta-pro-portable-power-station?variant=43725958873242',
                        za: 'https://za.ecoflow.com/products/delta-pro-portable-power-station?variant=41601871610065',
                    };
                    return localMap[locale] || localMap.us;
                })(),
                productId: (() => {
                    const localMap: any = {
                        us: '6585086836809',
                        ca: '6944959824026',
                        za: '7027758137553',
                    };
                    return localMap[locale] || localMap.us;
                })(),
                variantId: (() => {
                    const localMap: any = {
                        us: '40516140138569',
                        ca: '43725958873242',
                        za: '41601871610065',
                    };
                    return localMap[locale] || localMap.us;
                })(),
                descArr: [t('secD_card1_desc1'), t('secD_card1_desc2'), t('secD_card1_desc3')],
                children: solarpanels.filter((item: any) => {
                    const keys: {
                        [key: string]: any;
                    } = {
                        za: ['400w', '220w', '160w'],
                        ca: ['400w', '220w', '500w'],
                        us: ['400w', '220w'],
                    };
                    return (keys?.[locale] || ['400w', '220w']).includes(item.id);
                }),
            },
            {
                tag: t('common_card_tag'),
                img: '',
                title: 'DELTA 3 Max Plus',
                power: '2048Wh Capacity | 2400W Output | 10ms UPS',
                id: 'delta3maxplus',
                link_more: (() => {
                    const localMap: any = {
                        us: 'https://us.ecoflow.com/products/delta-3-max-series-portable-power-station?variant=54718699962441',
                        ca: 'https://ca.ecoflow.com/products/delta-3-max-series-portable-power-station?variant=62106661618035',
                    };
                    return localMap[locale] || localMap.us;
                })(),
                productId: (() => {
                    const localMap: any = {
                        us: '15386147061833',
                        ca: '15164532654451',
                    };
                    return localMap[locale] || localMap.us;
                })(),
                variantId: (() => {
                    const localMap: any = {
                        us: '54718699962441',
                        ca: '62106661618035',
                    };
                    return localMap[locale] || localMap.us;
                })(),
                descArr: [
                    'The most lightweight 2kWh portable power station.* Cover your home essentials and outdoor adventures with quiet and reliable power.',
                ],
                children: solarpanels.filter((item: any) => ['400w', '4*125w'].includes(item.id)),
            },
            {
                img: ``,
                tag: locale === 'ca' ? '' : t('common_card_tag'),
                power: t('secD_card2_power'),
                title: t('secD_card2_title'),
                id: 'delta2max',
                bestSelling: true,
                link_more: (() => {
                    const localMap: any = {
                        us: 'https://us.ecoflow.com/products/delta-2-max-portable-power-station?variant=40538145095753',
                        ca: 'https://ca.ecoflow.com/products/delta-2-max-portable-power-station?variant=43592212775066',
                        za: 'https://za.ecoflow.com/products/delta-2-max-portable-power-station?variant=41935518335185',
                    };
                    return localMap[locale] || localMap.us;
                })(),
                productId: (() => {
                    const localMap: any = {
                        us: '6905537888329',
                        ca: '7825964400794',
                        za: '7352407982289',
                    };
                    return localMap[locale] || localMap.us;
                })(),
                variantId: (() => {
                    const localMap: any = {
                        us: '40538145095753',
                        ca: '43592212775066',
                        za: '41935518335185',
                    };
                    return localMap[locale] || localMap.us;
                })(),
                descArr: [t('secD_card2_desc1'), t('secD_card2_desc2'), t('secD_card2_desc3')],
                children: solarpanels.filter((item: any) =>
                    (locale === 'za' ? ['400w', '220w', '160w', '120w'] : ['400w', '220w', '160w', '110w']).includes(item.id),
                ),
            },
            {
                img: ``,
                tag: locale === 'ca' ? '' : t('common_card_tag'),
                power: '1024Wh |1800W',
                title: 'DELTA 3 Classic',
                id: 'delta3classic',
                bestSelling: true,
                link_more: (() => {
                    const localMap: any = {
                        us: 'https://us.ecoflow.com/products/delta-3-classic-portable-power-station?variant=54691871227977',
                        ca: 'https://ca.ecoflow.com/products/delta-3-classic-portable-power-station?variant=62060639584627',
                    };
                    return localMap[locale] || localMap.us;
                })(),
                productId: (() => {
                    const localMap: any = {
                        us: '15386067730505',
                        ca: '15164532916595',
                    };
                    return localMap[locale] || localMap.us;
                })(),
                variantId: (() => {
                    const localMap: any = {
                        us: '54691871227977',
                        ca: '62060639584627',
                    };
                    return localMap[locale] || localMap.us;
                })(),
                descArr: ['Ultra-versatile 4 charging options and a 45-minute fast-charge.'],
                children: solarpanels.filter((item: any) => ['220w'].includes(item.id)),
            },
            {
                img: ``,
                tag: locale === 'ca' ? '' : t('common_card_tag'),
                power: t('secD_card3_power'),
                title: t('secD_card3_title'),
                id: 'delta2',
                link_more: (() => {
                    const localMap: any = {
                        us: 'https://us.ecoflow.com/products/delta-2-portable-power-station?variant=40569176326217',
                        ca: 'https://ca.ecoflow.com/products/delta-2-portable-power-station?variant=43725896056986',
                        za: 'https://za.ecoflow.com/products/delta-2-portable-power-station?variant=41620506575057',
                    };
                    return localMap[locale] || localMap.us;
                })(),
                productId: (() => {
                    const localMap: any = {
                        us: '6806217719881',
                        ca: '7440912384154',
                        za: '7187057803473',
                    };
                    return localMap[locale] || localMap.us;
                })(),
                variantId: (() => {
                    const localMap: any = {
                        us: '40569176326217',
                        ca: '43725896056986',
                        za: '41620506575057',
                    };
                    return localMap[locale] || localMap.us;
                })(),
                descArr: [t('secD_card3_desc1'), t('secD_card3_desc2'), t('secD_card3_desc3')],
                children: solarpanels.filter((item: any) =>
                    (locale === 'za' ? ['400w', '220w', '160w', '120w'] : ['400w', '220w', '160w', '110w']).includes(item.id),
                ),
            },
            {
                tag: locale === 'ca' ? '' : t('common_card_tag'),
                img: '',
                title: 'EcoFlow DELTA 3 Plus',
                power: '1024Wh I 1800W I 2600W X-Boost',
                id: 'd3p',
                bestSelling: true,
                link_more: (() => {
                    const localMap: any = {
                        us: 'https://us.ecoflow.com/products/delta-3-plus-portable-power-station?variant=41826182496329',
                        ca: 'https://ca.ecoflow.com/products/delta-3-plus-portable-power-station?variant=51645140926835',
                    };
                    return localMap[locale] || localMap.us;
                })(),
                productId: (() => {
                    const localMap: any = {
                        us: '7289136054345',
                        ca: '8331157766298',
                    };
                    return localMap[locale] || localMap.us;
                })(),
                variantId: (() => {
                    const localMap: any = {
                        us: '41826182496329',
                        ca: '51645140926835',
                    };
                    return localMap[locale] || localMap.us;
                })(),
                descArr: ['<10ms UPS', 'fully charged in 1 hour', 'Expands up to 5kWh'],
                children: solarpanels.filter((item: any) => ['400w', '220w', '160w', '110w'].includes(item.id)),
            },
        ];
    }

    const [cardLists, setCardLists] = useState(cards);

    const handleBuy = (card: any) => {
        try {
            const targetChild = card?.children?.find((child: any) => child?.isActive);
            gtm.push({
                event: 'uaEvent',
                event_name: 'bundle_add_to_cart',
                list_name: t('secC_title'),
                product_name: card?.title || card?.productTitle || card?.skuTitle,
                price: card?.compareAtPrice + (targetChild ? targetChild?.compareAtPrice * targetChild?.quantity : 0),
                tag: card?.tag || 'none',
                quantity: 1,
                button_name: t('common_card_buy'),
            });
            // fb埋点
            // @ts-ignore
            window?.fbq && window?.fbq('track', 'Search');
        } catch (e) {
            console.error(e);
        } finally {
            // window.open(card?.link_buy, '_blank');
            const target = card?.children?.find((item: any) => item.isActive);
            const addCarts: ItfEcoCartItem[] = [
                {
                    compareAtPrice: card?.compareAtPrice,
                    price: card?.price,
                    inventoryQuantity: card?.inventoryQuantity,
                    inventoryPolicy: card?.inventoryPolicy,
                    productId: card?.productId,
                    variantId: card?.variantId,
                    img: card?.img,
                    variantImg: card?.variantImg,
                    productTitle: card?.productTitle,
                    skuTitle: card?.skuTitle,
                    quantity: 1,
                },
            ];
            if (target?.quantity > 0) {
                addCarts.push({
                    compareAtPrice: target?.compareAtPrice,
                    price: target?.price,
                    inventoryQuantity: target?.inventoryQuantity,
                    inventoryPolicy: target?.inventoryPolicy,
                    productId: target?.productId,
                    variantId: target?.variantId,
                    img: target?.img,
                    variantImg: target?.variantImg,
                    productTitle: target?.productTitle,
                    skuTitle: target?.skuTitle,
                    quantity: target?.quantity,
                });
            }
            EcoDesignEventsBus.emit(ENUM_ECO_CART_EVENT.ECO_CART_ADD, addCarts);
        }
    };

    const handleClick = (card: any, k: number, m: number) => {
        const tempArr = JSON.parse(JSON.stringify(cardLists));
        const tempChildren = JSON.parse(JSON.stringify(tempArr[k].children));
        const activeIdx = tempChildren.findIndex((item: any) => item.isActive);
        tempChildren[activeIdx].isActive = false;
        tempChildren[m].isActive = true;
        setSolarStatu(tempArr[k], tempChildren[m]);
        handleCalclate(tempArr[k], tempChildren[m]);
        const newArr = JSON.parse(JSON.stringify([...tempArr?.slice(0, k), { ...tempArr[k], children: [...tempChildren] }, ...tempArr?.slice(k + 1)]));
        setCardLists(newArr);
    };

    const handleCount = (data: any, num: number, k: number, m: number) => {
        const tempArr = JSON.parse(JSON.stringify(cardLists));
        const tempChildren = JSON.parse(JSON.stringify(tempArr[k].children));
        tempChildren[m].quantity = num;
        setSolarStatu(tempArr[k], tempChildren[m]);
        handleCalclate(tempArr[k], tempChildren[m]);
        const newArr = JSON.parse(JSON.stringify([...tempArr?.slice(0, k), { ...tempArr[k], children: [...tempChildren] }, ...tempArr?.slice(k + 1)]));
        setCardLists(newArr);
    };

    const handleCalclate = (card: any, list: any) => {
        card.energy = calcTotalEnergy(list?.energy, list?.quantity);
        card.saveMoney = calcTotalSave(list?.energy, list?.quantity, locale);
    };

    const setSolarStatu = (item: any, child?: any) => {
        if (!child && item?.children && item?.children.length) {
            child = JSON.parse(JSON.stringify(item?.children?.find((list: any) => list?.isActive)));
        }
        // 推荐状态：0 数量0-置灰 1：推荐 2:不推荐
        item.statu = child?.quantity === 0 ? 0 : child?.recommand?.includes(child?.quantity) ? 1 : 2;
    };

    const AddSubtractor = ({ data, callback, k, m }: any) => {
        const NUM_MIN = 0;
        const NUM_MAX = data?.inventoryQuantity ?? 1000;
        const { useState } = useGlobal();
        const [number, setNumber] = useState(data?.quantity ?? 1);

        const reduceNumber = () => {
            if (number <= NUM_MIN) return false;
            setNumber(number - 1);
            callback(data, number - 1, k, m);
        };

        const addNumber = () => {
            if (number >= NUM_MAX) return false;
            setNumber(number + 1);
            callback(data, number + 1, k, m);
        };

        const inputChange = (e: any) => {
            const v = e.target.value.replace(/[^0-9]/g, '');
            if (v < NUM_MIN || v > NUM_MAX || !Boolean(Number(v))) {
                return;
            }
            setNumber(Number(v));
            callback(data, Number(v), k, m);
        };

        return (
            <div className="addSubtractor">
                <div className={number <= NUM_MIN ? 'addSubtractor-reduce disable' : 'addSubtractor-reduce'} onClick={reduceNumber}>
                    -
                </div>
                <input className="addSubtractor-number" value={number} onChange={inputChange} />
                <div className={number >= NUM_MAX ? 'addSubtractor-add disable' : 'addSubtractor-add'} onClick={addNumber}>
                    +
                </div>
            </div>
        );
    };

    useEffect(() => {
        if (typeof window !== 'undefined') {
            const resetGap = () => {
                const winW = window.innerWidth;
                if (winW >= 1440) {
                    return setGap(24);
                } else if (winW > 1024) {
                    return setGap(20);
                } else {
                    return setGap(16);
                }
            };
            resetGap();
        }
    }, []);

    const getAsynItem = async (item: any) => {
        const { productId, variantId, link_more } = item;
        return await new Promise(async (resolve, reject) => {
            try {
                const res = await getSolarRecommand({ productId, variantId }, locale);

                if (res?.code === '0') {
                    if (link_more) {
                        handleCalclate(item, item.children[0]);
                    }
                    item.link_buy = `https://${locale}.ecoflow.com/cart/${variantId}:1?channel=buy_button`;
                    if (res?.data?.handle) {
                        item.link_more = `https://${locale}.ecoflow.com/products/${res?.data?.handle}?variant=${variantId}`;
                    }

                    return resolve({ ...item, ...res?.data });
                } else {
                    console.error(res?.message);
                    return reject({ ...item });
                }
            } catch (e) {
                console.error(e);
                return reject({ ...item });
            }
        });
    };

    useEffect(() => {
        if (flag) {
            const tempSolarPanelsArr = JSON.parse(JSON.stringify(SolarPanels));
            const solarPromises = tempSolarPanelsArr?.map((item: any) => getAsynItem(item));
            Promise.all(solarPromises)
                .then((res: any) => {
                    setSolarpanels(res);
                    setFlag2(true);
                })
                .catch((e) => {
                    console.error(e);
                });
        }
    }, [flag]);

    useEffect(() => {
        const tempArr = JSON.parse(JSON.stringify(cardLists));
        const promises = tempArr?.map((item: any) => getAsynItem(item));
        Promise.all(promises)
            .then((res: any) => {
                setCardLists(res);
                setFlag(true);
            })
            .catch((e) => {
                console.error(e);
            });
    }, []);

    useEffect(() => {
        if (flag && flag2) {
            const tempArr = JSON.parse(JSON.stringify(cardLists));

            tempArr?.map((item: any) => {
                // item.children = JSON.parse(
                //     JSON.stringify(item?.id === 'deltapro3' ? solarpanels.slice(0, 2) : item?.id === 'deltapro' ? solarpanels.slice(0, 3) : solarpanels),
                // );

                item.children = cloneDeep(
                    item.children.map((child: any) => {
                        return solarpanels.find((item: any) => item.id === child.id);
                    }),
                ).filter((item: any) => !!item);
                item.children.forEach((item: any) => (item.isActive = false));
                if (item.children[0]) {
                    item.children[0].isActive = true;
                }

                if (['us', 'ca'].includes(locale)) {
                    if (['d3p', 'delta2max', 'delta2'].includes(item.id)) {
                        const _item = item.children.find((item: any) => item.id === '220w');
                        if (_item) {
                            _item.bestSelling = true;
                        }
                    }
                }

                item?.children?.map((child: any) => {
                    child.cartTitle = `${child?.cartTitle}`;
                    // child.parentVariantId = item?.variantId;
                    child.recommand = getRecommand(item?.id, String(child?.id));
                    if (child?.inventoryQuantity < 0) {
                        child.quantity = 0;
                    } else if (child?.recommand?.length > 0 && child?.inventoryQuantity < child?.recommand[0]) {
                        child.quantity = child?.inventoryQuantity;
                    } else {
                        child.quantity = child?.recommand?.length > 0 ? child?.recommand[0] : 0;
                    }
                });
                setSolarStatu(item, item?.children[0]);
                handleCalclate(item, item?.children[0]);
            });
            setCardLists(tempArr);
            setFlag3(true);
        }
    }, [solarpanels, flag, flag2]);

    return (
        <div id="cost-saving-D" className={`cost-saving-D cost-saving-box inner ${css['cost-saving-D']}`}>
            <Swiper
                className="cards swiper-box"
                effect="fade"
                modules={[Scrollbar]}
                spaceBetween={gap}
                slidesPerView={'auto'}
                initialSlide={0}
                scrollbar={{
                    hide: false,
                    draggable: true,
                    dragSize: 32,
                    snapOnRelease: true,
                }}
            >
                {cardLists?.map((card: any, k: number) => (
                    <SwiperSlide className={`swiper-item item-${k + 1}`} key={k}>
                        {card?.tag && <span className="card-tag">{card?.tag}</span>}
                        <div className="card-img">
                            <EFPicture src={card?.img || card?.variantImg} alt={card?.title} />
                        </div>
                        <p className="card-power">{card?.power}</p>
                        <p className="card-title">{card?.title || card?.productTitle || card?.skuTitle}</p>
                        <ul className="card-descs">
                            {card?.descArr?.map((desc: any, m: number) => (
                                <li className="card-desc li" key={`${k}_${m}`}>
                                    {desc}
                                </li>
                            ))}
                        </ul>
                        <p className="card-line"></p>
                        <div className={`calc-info`}>
                            <p className={`card-calc`}>{t('common_card_calculator')}</p>
                            <p className={`card-calc-res ${card?.statu === 0 ? 'gray' : card?.statu === 1 ? 'recommand' : 'not-recommand'}`}>
                                {card?.statu === 0
                                    ? t('common_card_0')
                                    : card?.statu === 1
                                    ? t.rich('common_card_calculator_res', {
                                          power: card?.energy,
                                          money: card?.saveMoney,
                                          h: (text: string) => (
                                              <span className="h">
                                                  {t('common_card_unit')}
                                                  {text}
                                              </span>
                                          ),
                                      })
                                    : t('common_card_no_recommand')}
                            </p>
                        </div>
                        <div className="card-output">
                            <p className="output-text">{t('secD_card_output')}</p>
                            <ul className="output-lists">
                                {card?.children?.map((list: any, m: number) => (
                                    <li className={`output-list ${list?.isActive ? 'active' : ''}`} key={`${k}_${m}`} onClick={() => handleClick(card, k, m)}>
                                        {list?.title}

                                        {['us', 'ca'].includes(locale) && list?.bestSelling && <BestSelling className="best-selling" />}
                                    </li>
                                ))}
                            </ul>
                        </div>
                        <div className="card-quantity card-output">
                            <p className="output-text">{t('secD_card_quantity')}</p>
                            <ul className="quantity-lists">
                                {card?.children?.map((list: any, m: number) => (
                                    <li className={`quantity-list ${list?.isActive ? 'show' : 'hide'}`} key={`${k}_${m}`}>
                                        <AddSubtractor data={list} callback={handleCount} k={k} m={m} />
                                    </li>
                                ))}
                            </ul>
                        </div>
                        <div className="card-btns">
                            {card?.link_buy && (
                                <>
                                    {Number(card?.inventoryQuantity) <= 0 ? (
                                        <button disabled className={`btn-buy card-btn disable`}>
                                            {t('common_card_out')}
                                        </button>
                                    ) : (
                                        <p className={`btn-buy card-btn`} onClick={() => flag && flag2 && flag3 && handleBuy(card)}>
                                            {t('common_card_buy')}
                                        </p>
                                    )}
                                </>
                            )}
                            {card?.link_more && (
                                <Link
                                    className="btn-more card-btn"
                                    href={`${card?.link_more}${
                                        String(card?.link_more)?.indexOf('?') !== -1 ? '&' : '?'
                                    }utm_source=scenario+page&utm_medium=Pillar`}
                                    dataLayer={{
                                        // event: 'uaEvent',
                                        // event_name: 'select_product',
                                        // list_name: t('secD_title'),
                                        // product_name: card.title,
                                        // button_name: t('common_card_more'),
                                        event: 'uaEvent',
                                        event_name: 'buy',
                                        product_name: card?.title,
                                        position: 'Cost Saving Page',
                                    }}
                                >
                                    {t('common_card_more')}
                                </Link>
                            )}
                        </div>
                    </SwiperSlide>
                ))}
            </Swiper>
        </div>
    );
}
